import moment from "moment";
import {
  Badge,
  CurrencyDisplay,
  OverflowMenuDropDown,
  OverflowMenuDropDownItem,
} from "../../components";
import { appConfig } from "../../configs";

import { IViewPayout, StatusColors } from "../../interfaces-and-types";
import {
  getPayoutStatusIndicator,
  truncateStringWithEllipsis,
} from "../../utils";

export const payoutsDisplayFormatter = (item: IViewPayout) => {
  const statusIndicator: { statusText: string; statusType: StatusColors } =
    getPayoutStatusIndicator(item);

  return {
    ...item,
    amount: (
      <CurrencyDisplay currencyOrSymbol={item.currency} amount={item.amount} />
    ),
    bank_name: (
      <strong
        title={
          item.settled_to_wallet
            ? "This payout was settled to the wallet of same currency"
            : item.bank_name
        }
      >
        {item.settled_to_wallet ? (
          <span className="text-primary font-ctm--bold">WALLET SETTLEMENT</span>
        ) : (
          truncateStringWithEllipsis(item.bank_name, 40)
        )}
      </strong>
    ),
    account_number: (
      <strong className="font-ctm--bold">{item.account_number}</strong>
    ),
    account_name: (
      <strong title={item.account_name}>
        {truncateStringWithEllipsis(item.account_name, 30)}
      </strong>
    ),
    status: (
      <Badge
        text={statusIndicator.statusText}
        statusColor={statusIndicator.statusType}
      />
    ),
    created_at: (
      <span className="date--oneline">
        {moment(item.created_at).format(appConfig.dateTimeFormat)}
      </span>
    ),
    paid_at: (
      <span className="date--oneline">
        {!item.paid_at
          ? "..."
          : moment(item.paid_at).format(appConfig.dateTimeFormat)}
      </span>
    ),
    more: item.payout_failed ? (
      <OverflowMenuDropDown
        focusTrap={false}
        data-floating-menu-container
        size="sm"
        flipped
      >
        <OverflowMenuDropDownItem
          index={1}
          itemText="Retry Payout"
          onClick={item.openRetryPayoutModal}
        />
      </OverflowMenuDropDown>
    ) : null,
  };
};
